import * as React from "react";
import styled from "styled-components";
import { formatDateTime } from "../../shared/dateTimeUtils";
import InfoDialog from "./InfoDialog";
import "./ahi.scss";
import { AHI_IMAGES } from "./constants";
import { postOpsLog } from "../../serviceCalls";
import { launchAhiSystemFn } from "./AhiScore";

const AhiChiclet = ({ disabled, data, ahiDescriptions }) => {
  /** ************************************************* SETUP *************************************************** */

  /** ************************************************* HOOKS *************************************************** */

  /** *********************************************** FUNCTIONS ************************************************* */

  const launchAhiSystem = launchAhiSystemFn({ data, postOpsLog });

  /** ************************************************* RENDER ************************************************** */
  return (
    <ChicletWrapper>
      <ChicletTitleWrapper>
        <ChicletTitle>AHI-PI</ChicletTitle>
        <ChicletTitle>
          <InfoDialog showText={false} ahiDescriptions={ahiDescriptions} />
        </ChicletTitle>
      </ChicletTitleWrapper>

      {disabled ? (
        <DisabledWrapper>--</DisabledWrapper>
      ) : (
        <Wrapper onClick={launchAhiSystem}>
          <Section>
            <StyledImg src={AHI_IMAGES[data.ahiPi]} />
            <Column>
              <AhiLabel>{data.ahiText}</AhiLabel>
              <Column>
                <RiskText>{data.ahiType}</RiskText>
                <RiskText>{formatDateTime(data.ahiWindowEnd)}</RiskText>
              </Column>
            </Column>
          </Section>
        </Wrapper>
      )}
    </ChicletWrapper>
  );
};

export default AhiChiclet;

/** ************************************************* STYLES ************************************************** */

const ChicletWrapper = styled.div`
  min-height: 80px;
  width: 240px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  border: 1px solid #979797;
  border-bottom: 0;
  margin-right: -1px;
  cursor: pointer;
`;

const ChicletTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #f6f6f6;
`;

const ChicletTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 11px;
  background-color: #f6f6f6;
  animation: marquee 5s both;
  overflow: hidden;
  border-bottom: 0;
  font-size: 10px;
  padding-left: 0.5em;
  min-height: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding-left: 24px;
`;

const DisabledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-left: 14px;
  background-color: #f6f6f6;
  align-self: center;
  font-weight: 500;
  font-size: 20px;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AhiLabel = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  font-weight: 700;
`;

const StyledImg = styled.img`
  height: 36px;
  width: 36px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 4px;
  padding-top: 2px;
`;

const RiskText = styled.div`
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  font-size: 10px;
`;
